import {AppStartListening} from '@/redux/store/listenerMiddleware';
import callBellLogsService from '@/services/callBellLogsService';

import {getMissedCallBellLogsCount, getMissedCallBellLogsCountError, getMissedCallBellLogsCountSuccess} from './slice';

const addFeatureListeners = (startListening: AppStartListening) => {
    startListening({
        actionCreator: getMissedCallBellLogsCount,
        effect: async (_action, listenerApi) => {
            try {
                const respData = await callBellLogsService.getMissedCallBellLogsCount();
                listenerApi.dispatch(getMissedCallBellLogsCountSuccess(respData?.callbackRequestCount));
            } catch (error) {
                listenerApi.dispatch(getMissedCallBellLogsCountError());
                console.error('Get user features failed');
            }
        },
    });
};

export default addFeatureListeners;
